import {
    SET_SEARCH_OPEN_VISIBILITY,
    SET_SEARCH_CLOSE_VISIBILITY,
    SET_INPUT_SEARCH,
    SET_SEARCH_DETAILS,
    CLEAR_SUGGESTION
} from '../constants/headerActionTypes';

  const initialState = {
    searchVisibility: 'none',
    suggestions: [],
    error: {}
  }

  export default function (state, action) {
    if (typeof state === 'undefined') {
      state = initialState;
    }
    switch (action.type) {
      case SET_SEARCH_OPEN_VISIBILITY:
        return {
          ...state,
          searchVisibility: 'block'
        };
      case SET_SEARCH_CLOSE_VISIBILITY:
        return {
          ...state,
          searchVisibility: 'none'
        };
        case SET_INPUT_SEARCH:
        return {
          ...state,
          searchKeys: action.payload,
          suggestions: action.payload
        };
        case SET_SEARCH_DETAILS:
        return {
          ...state,
          searchDetails: action.payload,
          inputText:action.payload[0].inputText
        };
      case CLEAR_SUGGESTION:
        return {
          ...state,
          suggestions: []
        }
      default:
        return state;
    }
  }
